import {CalculatedRainWater, Marker} from "../App";
import React, {Dispatch, useEffect, useState} from "react";
import "./SummaryStep.scss";
import ProductList from "../ProductList/ProductList";
import {getIconUrl, getShareReportHash} from "../helpers";
import {Tooltip} from "react-tooltip";
import ReportLinkPopup from "../Summary/ReportLinkPopup";
import ContactPopup from "../Summary/ContactPopup";

type Props = {
    calculatedRainWater: CalculatedRainWater|null,
    setStep: Dispatch<string>
    marker: Marker | undefined
}
function SummaryStep({calculatedRainWater, setStep, marker}: Props) {
    const [showShare, setShowShare] = useState<boolean>(false);
    const [showContact, setShowContact] = useState<boolean>(false);
    const [link, setLink] = useState<string>("");
    const [reportHash, setReportHash] = useState<string>("");
    const urlShareReportHash = getShareReportHash();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const prevStep = (e: React.MouseEvent) => {
        console.log('prevStep')
        e.preventDefault();
        setStep('dataFrom')
    }

    if (!marker || !calculatedRainWater) {
        return <div><h4>Błąd, kalkulatora. Skontaktuj się z obsługą klienta</h4></div>;
    }

    const minSizeTank = calculatedRainWater.minSizeTank;
    const recommendedSizeTank = calculatedRainWater.recommendedSizeTank;
    console.log(calculatedRainWater);

    return <div className={'SummaryStep'}>
        <div className={'topDescription'}>
            <h2>KROK III</h2>
            <h3>ZAPOZNAJ SIĘ Z RAPORTEM I DOBIERZ ODPOWIEDNI ZBIORNIK:</h3>
            Kliknij zielony przycisk PRODUKTY DLA CIEBIE, aby sprawdzić propozycje zbiorników z oferty naszego sklepu,
            które będą najlepszym wyborem przy tych parametrach. Jeśli chcesz zachować informacje na później - kliknij
            niebieski przycisk PRZEŚLIJ RAPORT NA MAIL, który wyśle na Twój mail link z uzyskanymi wynikami. Jeśli masz
            dodatkowe pytania naciśnij KONTAKT Z DORADCĄ.
        </div>
        <div className="row">
            <div className='topButtonsContainer'>
                {!urlShareReportHash ? <a className={"yellow-button"} onClick={prevStep}>&lt; Przelicz ponownie</a> : <a className={"yellow-button"} href={'/kalkulator-deszczowki/'} target={'_blank'}>Nowe obliczenia</a>}
                <a className={"yellow-button green-button"} href={'#propozycje'}>Produkty dla ciebie &gt;</a>
                <a className={"yellow-button blue-button"} onClick={() => setShowShare(true)}>Prześlij raport na email</a>
                <a className={"yellow-button blue-button"} onClick={() => setShowContact(true)}>Kontakt z doradcą</a>
            </div>
        </div>
        <div className="row summaryContainer">
            <div className="col-1 col-lg-3"></div>
            <div className="col-10 col-lg-6">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className='colContainer upperText'>
                            <img src={getIconUrl('lokalizacja-2.svg')}/> Twoja <br/>Miejscowość
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className='colContainer blueText'>
                            <b>{marker.name}</b>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='line'/>
                </div>

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className='colContainer upperText'>
                            <img src={getIconUrl('opady-2.svg')}/> Średnie <br/>opady roczne
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className='colContainer blueText'>
                            <b>{marker.rainWaterDescription} mm/m2</b>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='line'/>
                </div>

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className='colContainer upperText'>
                            <img src={getIconUrl('uzysk.svg')}/> Uzysk wody <br/>deszczowej
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className='colContainer blueText'>
                            <b>{calculatedRainWater.expectedRainWater} litrów/rok</b>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='line'/>
                </div>

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className='colContainer upperText'>
                            <img src={getIconUrl('zapotrzebowanie.svg')}/> Zapotrzebowanie <br/>na deszczówkę
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className='colContainer blueText'>
                            <b>{calculatedRainWater.requiredRainWater} litrów</b>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='line'/>
                </div>

                {recommendedSizeTank != minSizeTank && <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className='colContainer upperText'>
                            <img src={getIconUrl('pojemnosc-min-2.svg')}/> Minimalna <br/>pojemność <br/> zbiornika
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className='colContainer blueText'>
                            <b>{!minSizeTank ? "-" : minSizeTank} litrów</b>
                        </div>
                    </div>
                </div>}

                {recommendedSizeTank != minSizeTank && <div className="row">
                    <div className='line'/>
                </div>}

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className='colContainer upperText'>
                            <img
                                src={getIconUrl('pojemnosc-proponowana.svg')}/> Proponowana <br/>pojemność <br/> zbiornika
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className='colContainer blueText'>
                            <b>{!recommendedSizeTank ? "-" : recommendedSizeTank} litrów</b>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='line'/>
                </div>

                {calculatedRainWater.expectedRainWater && <div className="row grayBackground">
                    <div className="col-12 col-lg-6">
                        <div className='colContainer upperText'>
                            <img src={getIconUrl('oszczednosc.svg')}/> Oszczędności z proponowanej pojemności:
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className='colContainer greenText'>
                            <b>{Math.floor((calculatedRainWater.expectedRainWater / 1000) * 9.96)} zł/rok</b> <a
                            className='tooltip-icon' data-tooltip-id="summary-tooltip"
                            data-tooltip-content="Podana kwota obliczona dla średniej ceny wody wodociągowej w Polsce w roku 2022 według danych PGW WP, która wyniosła 9,96 zł/m3. Pojedynczy zapas dotyczy wykorzystania całości uzyskanej wody w zbiorniku o proponowanej pojemności."><span>?</span></a>
                        </div>
                    </div>
                </div>}
                {calculatedRainWater.expectedRainWater && <div className="row grayBackground">
                    <div className='line'/>
                </div>}
            </div>
        </div>

        <div className="products" id={'propozycje'}>
            {minSizeTank && <div>
                <div className='description-box'>
                    <h3>Propozycje zbiorników według minimalnego zapotrzebowania</h3>
                    Zbiorniki, które według uzyskanych wyżej wyników polecamy dla Twojej nieruchomości.
                </div>
                <ProductList sizeTank={minSizeTank} recommendedSizeTank={recommendedSizeTank}/>
            </div>}
            {recommendedSizeTank && recommendedSizeTank != minSizeTank && <div className="mt-3">
                <div className='description-box'>
                    <h3>Propozycje zbiorników według proponowanej pojemności</h3>
                    Ze względu na nieregularność opadów podczas często występującej w Polsce suszy, zachęcamy do tworzenia systemów gromadzących większe ilości deszczówki.
                </div>
                <ProductList sizeTank={recommendedSizeTank} recommendedSizeTank={recommendedSizeTank}/>
            </div>}
        </div>
        <div className='center-buttons'>
            <div>
                <a className={"yellow-button"} onClick={() => window.scrollTo(0, 0)}> ↑ powrót do góry strony ↑</a>
            </div>
        </div>
        {showShare && <ReportLinkPopup
            setShowShare={setShowShare}
            marker={marker}
            calculatedRainWater={calculatedRainWater}
            link={link}
            setLink={setLink}
            reportHash={reportHash}
            setReportHash={setReportHash}
        />}

        {showContact && <ContactPopup
            setShowContact={setShowContact}
            marker={marker}
            calculatedRainWater={calculatedRainWater}
            link={link}
            setLink={setLink}
            reportHash={reportHash}
            setReportHash={setReportHash}
        />}
        <Tooltip id="summary-tooltip"/>
    </div>
}

export default SummaryStep;